import { TradingTerminal } from "@/features/terminal";

export function TerminalPage() {
  return <TradingTerminal />;
}
